import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import db from "../../../api/mongodb";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { defaultOptions1 } from "../../../config/loading-config.js";
// import Lottie from "react-lottie";
import "./ClientsGridView.scss";
import DummyProfilePic from "../../../images/dummy-profile-picture.svg";

const ClientGridList = ({ clients }) => {
  const renderedList = clients.map((client) => {
    // var convertedDate = safeAP.createdAt.toString().substring(0, 10);
    var safeAPItem = null;

    safeAPItem = (
      <Col xl={4} lg={6} md={6} sm={12} key={client._id}>
        <div className="client-card">
          {client.formData.clientProfileImg && client.formData.clientProfileImg.length ? (
            <img src={client.formData.clientProfileImg[0].content} alt="" />
          ) : (
            <img src={DummyProfilePic} alt="" />
          )}
          <h2 className="client-title">
            {client.formData.clientFirstName} {client.formData.clientLastName}
          </h2>
          <Link to={`/clients/profile/${client._id}`}>
            <Button className="btn-primary">View Profile</Button>
          </Link>
        </div>
      </Col>
    );

    return safeAPItem;
  });

  return <>{renderedList}</>;
};

export default ClientGridList;
